import React from 'react';

import { useIntl } from 'react-intl';

import { FriesOffersSvg } from 'components/svgs/fries-offers';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import {
  EmptyScreenWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const OffersEmptyScreen: React.FC = () => {
  const { formatMessage } = useIntl();
  const { noStoreSelected } = useStoreContext();
  // Texts and link path change depending on store is select or not
  const headerText = noStoreSelected ? 'offersNoLocationSelected' : 'offersNoOffersAvailable';
  const subHeaderText = noStoreSelected
    ? 'offersSelectStoreToViewOffers'
    : 'offersYouCanStillEnjoyYourFavorites';
  const linkText = noStoreSelected ? 'offersSelectStore' : 'orderNow';
  const linkPath = noStoreSelected ? routes.storeLocator : routes.menu;

  return (
    <EmptyScreenWrapper>
      <ImageWrapper>
        <FriesOffersSvg />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: headerText })}</HeaderText>
      <SubText>{formatMessage({ id: subHeaderText })}</SubText>
      <StyledActionButtonLink to={linkPath}>
        {formatMessage({ id: linkText })}
      </StyledActionButtonLink>
    </EmptyScreenWrapper>
  );
};

export default OffersEmptyScreen;
